export async function beginConversation(target: HTMLIFrameElement|Window, origin: string = window.location.origin): Promise<MessagePort> {
    // Implements happy-eyeballs
    const cw = target instanceof HTMLIFrameElement ? target.contentWindow! : target;
    let port = [null as number|null];

    let attempt = 0;
    let channels: {port1: MessagePort, port2: MessagePort, idx: number}[] = [];

    while (port[0] === null) {
        if (channels.length > 5) {
            const {port1, port2} = channels.shift()!;
            port1.close();
            port2.close();
        }

        const c = new MessageChannel();
        const a = attempt++;
        channels.push({port1: c.port1, port2: c.port2, idx: a});
        ((ch, idx) => {
            ch.port1.addEventListener("message", () => { port[0] = idx }, {once: true})
            cw.postMessage({"type": "start", "port": ch.port2}, origin, [ch.port2]);
            ch.port1.start();
        })(c, a);

        await new Promise((rs) => setTimeout(rs, 100));
    }

    const idx = channels.findIndex(({idx}) => idx === port[0]);
    const result = channels.splice(idx, 1)[0]!;
    channels.forEach(({port1, port2}) => {port1.close(); port2.close();});
    return result.port1;
} 


export async function acceptConversation(origin: string = window.location.origin): Promise<MessagePort> {
    return await new Promise(rs => {
        const initListener = (e: MessageEvent) => {
            if (e.origin !== origin) {
                console.debug("[embed] Got message from unexpected origin (actual, expected)", e.origin, origin);
                return;
            }
            if (!e.data || e.data["type"] !== "start" || !e.data["port"]) return;
            window.removeEventListener("message", initListener);

            e.data.port.start = () => {
                MessagePort.prototype.start.apply(e.data.port);
                e.data.port.postMessage({type: "ready"});
            };
            rs(e.data.port);
        };

        window.addEventListener("message", initListener);
    });
}
